import { glideConfig } from "../library/glide";
import handleMediaQueryChange from "../utilities/helpers/_media_query";

const topicSliderDesktop = () => {
    const topicPlugin = document.querySelectorAll("[data-topic-plugin] .glide");

    if (topicPlugin.length === 0) return;

    for (const plugin of topicPlugin) {
        const desktopPerView = 4;

        glideConfig(plugin, {
            type: "carousel",
            perView: desktopPerView,
            gap: 16,
            dragThreshold: false,
            swipeThreshold: false,
        });
    }
};

const topicSliderMobile = () => {
    const topicPlugin = document.querySelectorAll("[data-topic-plugin] .glide");

    if (topicPlugin.length === 0) return;

    for (const plugin of topicPlugin) {
        const slidesCount = plugin.querySelectorAll(".glide__slide").length;
        const mobilePerView = 1;

        glideConfig(plugin, {
            type: "carousel",
            perView: mobilePerView,
            focusAt: slidesCount <= mobilePerView ? 0 : "center",
            swipeThreshold: true,
            dragThreshold: true,
        });
    }
};

const topicSlider = () => {
    handleMediaQueryChange(topicSliderMobile, topicSliderDesktop);
};

const initializeTopicPlugin = () => {
    topicSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeTopicPlugin);
} else {
    initializeTopicPlugin();
}

export { topicSlider };
